import { notEmpty, typeUtils } from '@festina-life/core'
import type { FieldMetaProps } from 'formik'

import { useFormikContext } from './useFormikContext'

export const useFormikErrorWithState = ({
  error,
  touched,
}: FieldMetaProps<unknown>) => {
  const { submitCount, status } = useFormikContext()
  const safeStatus = status as unknown
  const hasFormValidated =
    typeUtils.hasField(safeStatus, 'hasFormValidated') &&
    safeStatus.hasFormValidated === true

  const isInError =
    notEmpty(error) && (touched || submitCount > 0 || hasFormValidated)

  return {
    isInError,
    error: isInError ? error : undefined,
  }
}
